import { useState, useEffect } from "react";
import { Container, Nav } from "react-bootstrap";
import { BsCircleFill } from "react-icons/bs";
import { useNavigate, useLocation } from "react-router-dom";
import "./SecondTabNavigation.css";
import "../../styles/typography.css";

const SecondTabNavigation = ({ tabConfig }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(
    Array.isArray(tabConfig[0].path) ? tabConfig[0].path[0] : tabConfig[0].path
  );

  useEffect(() => {
    const activeTab =
      tabConfig.find((tab) =>
        Array.isArray(tab.path)
          ? tab.path.some((p) => location.pathname.startsWith(p))
          : location.pathname.startsWith(tab.path)
      ) || tabConfig[0];

    setActiveKey(Array.isArray(activeTab.path) ? activeTab.path[0] : activeTab.path);
  }, [location.pathname, tabConfig]);

  const handleSelect = (selectedKey) => {
    if (selectedKey && selectedKey !== activeKey) {
      setActiveKey(selectedKey);
      navigate(selectedKey);
    }
  };

  const locationPath = location.pathname;
  const showStatusIcons =
    locationPath.endsWith("/analyst-tasks/myassignment") ||
    locationPath.endsWith("/analyst-tasks/peer-review");

  return (
    <Container fluid className="second-tab-container">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Nav
          variant="underline"
          activeKey={activeKey}
          onSelect={handleSelect}
          className="flex-nowrap"
        >
          {tabConfig.map((tab) => {
            const tabPath = Array.isArray(tab.path) ? tab.path[0] : tab.path;
            const isActive = Array.isArray(tab.path)
              ? tab.path.some((p) => location.pathname.startsWith(p))
              : location.pathname.startsWith(tab.path);

            return (
              <Nav.Item key={tabPath}>
                <Nav.Link
                  eventKey={tabPath}
                  className="second-tab-item header-default-style"
                  active={isActive}
                >
                  {tab.label}
                </Nav.Link>
              </Nav.Item>
            );
          })}
        </Nav>
        {showStatusIcons && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              marginLeft: 24,
              paddingRight: 16,
            }}
          >
            <BsCircleFill color="#43B324" size={10} className="me-1" />
            <span style={{ fontSize: 14 }}>Due &gt; 10</span>
            <BsCircleFill color="#E13B3B" size={10} className="me-1" />
            <span style={{ fontSize: 14 }}>Due &gt; 14</span>
          </div>
        )}
      </div>
    </Container>
  );
};

export default SecondTabNavigation;
